import { useRef } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { ITranslator } from 'types/intl';
import enUSMessages from './en-US.json';

const createGlobalIntlObj = (intl: IntlShape): ITranslator => ({
	...intl,
	tr: (id: string, values?: any, defaultMessage?: string) =>
		intl.formatMessage({ id, defaultMessage }, values)
});

export const DEFAULT_LOCALE = 'en-US';

export const intlMessages = {
	[DEFAULT_LOCALE]: enUSMessages
};

export const InitIntl = () => {
	const initRef = useRef(false);

	const intl = useIntl();
	globalThis.intl = createGlobalIntlObj(intl);
	if (!initRef.current) {
		initRef.current = true;
	}

	return null;
};
